module.exports = __webpack_public_path__ + "img/icon_t5_c.5e6a2346.png";